import React from 'react';

const About = () => {
    return (
        <section id="about" className="container pt-3 pb-5">
            <h1 className="text-center title mt-5"><b>About Us</b></h1>

            <article className="mt-4">
                <h2 className="brand">Sihah</h2>
                <h5><b>Making Your House A Home</b></h5>
                <h4 className="text-justify text-secondary mt-5">Sihah is where savvy shoppers of all interior styles discover an ever changing and evolving selection of home decor from far and wide. Our selection is unique, and there’s something for everyone to enjoy.</h4>
                <h4 className="text-justify text-secondary mt-4">We believe that your home should reflect your own personal style. Each corner of your life should be eye-catching and unique, just like you. Sihah is a home decor store, dedicated to helping our customers discover their own design personality. Browse through our wide selection today to find just what you have been searching for.</h4>
            </article>
        </section>
    );
};

export default About;